<script setup lang="ts">
import { useAttrs, computed } from "vue";
import { useViewport } from "~/composables/useViewport";
import { useI18n } from "~/composables/useI18n";

defineOptions({ inheritAttrs: false });

type OngoingBadgeVariant = "ongoing" | "completed" | "attended";

interface Props {
  title: string;
  subtitle?: string;
  description?: string;
  status?: OngoingBadgeVariant;
}

defineProps<Props>();

const attrs = useAttrs();
const isClickable = computed(() => !!attrs.onClick);

const { isSmallScreen } = useViewport();
const t = useI18n();
</script>

<template>
  <UiCard
    tag="article"
    rounded="lg"
    :class="{
      'cursor-pointer': isClickable && !isSmallScreen,
    }"
    v-bind="isClickable && !isSmallScreen ? { onClick: attrs.onClick } : {}"
  >
    <div class="flex flex-wrap items-start justify-between gap-2">
      <div class="min-w-0">
        <UiTitle level="4" class="text-sm font-semibold">
          {{ title }}
        </UiTitle>
        <UiParagraph v-if="subtitle" class="text-xs mt-0.5">
          {{ subtitle }}
        </UiParagraph>
      </div>
      <UiOngoingBadge v-if="status" :variant="status" />
    </div>
    <UiParagraph v-if="description" class="mt-2 text-xs">
      {{ description }}
    </UiParagraph>
    <UiButton
      v-if="isClickable && isSmallScreen"
      variant="solid"
      color="secondary"
      size="md"
      class="mt-4 lg:hidden w-full text-center"
      @click="(attrs.onClick as Function)()"
    >
      <span class="w-full">{{ t("learningPage.officialWebsiteLabel") }}</span>
    </UiButton>
  </UiCard>
</template>
